import { Component, OnInit } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { TdLoadingService } from '@covalent/core';
import { environment } from '../../../../../../environments/environment';
import { AdminService } from '../../../../../services/admin/admin.service';
import { AuthService } from '../../../../../services/auth.service';
import { Municipality } from '../../../../../services/Municipality';
import { MunicipalityService } from '../../../../../services/municipality.service';

@Component({
  selector: 'app-redirect-from-apps',
  templateUrl: './redirect-from-apps.component.html',
  styleUrls: ['./redirect-from-apps.component.scss']
})
export class RedirectFromAppsComponent implements OnInit {
  municipality: Municipality;

  constructor(
    private activatedRoute: ActivatedRoute,
    private _router: Router,
    private _loadingService: TdLoadingService,
    private _authService: AuthService,
    private _adminService: AdminService,
    private _municipalServise: MunicipalityService
  ) {
    this._municipalServise.currentMunicipality.subscribe((data) => {
      this.municipality = data;
    });
    this.activatedRoute.queryParams.subscribe(
      (query: { token: string; clientId: string }) => {
        this._loadingService.register();
        localStorage.setItem('clientId', query.clientId);
        sessionStorage.setItem('clientId', query.clientId);
        const privateToken = localStorage.getItem('private-token');
        if (!query.token && !privateToken) {
          this._loadingService.resolve();
          const isAdmin = this._router.url.includes('admin');
          const urlEndPoint = isAdmin ? 'private' : 'public';
          document.location.href = `${this.ssoUrl}/${urlEndPoint}/auth/login?redirectUrl=${document.location.href}`;
          //   this._router.navigate(['forbidden']);
        } else {
          localStorage.setItem('access_token', query.token);
          this._authService.checkOldToken.subscribe(
            (res) => {
              if (this._adminService._hasAccessToAdminPanel(res)) {
                this._loadingService.resolve();

                this._router.navigate(['admin']);
              } else {
                this._loadingService.resolve();
                const isAdmin = this._router.url.includes('admin');
                const urlEndPoint = isAdmin ? 'private' : 'public';

                document.location.href = `${this.ssoUrl}/${urlEndPoint}/auth/login?redirectUrl=${document.location.href}`;
                // this._router.navigate(['forbidden']);
              }
            },
            (err) => {
              if (err.status === 401 || err.status === 403) {
                this._loadingService.resolve();
                const isAdmin = this._router.url.includes('admin');
                const urlEndPoint = isAdmin ? 'private' : 'public';

                document.location.href = `${this.ssoUrl}/${urlEndPoint}/auth/login?redirectUrl=${document.location.href}`;
                // this._router.navigate(['forbidden']);
              }
            }
          );
        }
      }
    );
  }

  ngOnInit() {}
  get ssoUrl(): string {
    return environment.ssoUrl;
  }
}



// WEBPACK FOOTER //
// /opt/app-root/src/src/app/components/admin/components/shared/redirect-from-apps/redirect-from-apps.component.ts